import React, { useEffect } from 'react'
import {connect} from 'react-redux'
import * as actionCreators from '../actions/ExampleActions'
import {Navigation} from '../components/_Navigation'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useFirebase, useFirestoreConnect } from 'react-redux-firebase'
import { Button, Modal, Loader } from 'semantic-ui-react'

import {Message, Form} from 'semantic-ui-react'

export default function Login() {
  const firebase = useFirebase()
  const auth = useSelector(state => state.firebase.auth)
  const [ loading, setLoading ] = React.useState(false)
  const [ email, setEmail ] = React.useState("")
  const [ password, setPassword ] = React.useState("")
  const [ error, setError ] = React.useState(null)
    const [ showReset, setShowReset ] = React.useState(false);

    var provider = new firebase.auth.OAuthProvider('oidc.kisad');
    provider.addScope('roles');

    firebase.auth().languageCode = 'de';

    function login() {
        (async () => {
            setError(null);
            setLoading(true);
            try{
                
                await firebase.login({ email: email, password: password })
            }catch(e){
                setError(e);
            }
            setLoading(false);
        })();
    }

    function sendPasswordResetEmail(){
        firebase.auth().sendPasswordResetEmail(email).then(function() {
            setShowReset(false);
        }).catch(function(e) {
            console.log(e);
            setError(e);
        });
    }

    useEffect(() => {
        if(auth.isEmpty && auth.isLoaded)
            firebase.auth().signInWithRedirect(provider);
    }, [auth.isEmpty, auth.isLoaded]);

    return null;

  return (
    <div>
    {
        (showReset)?
            <Modal open={true} closeOnDimmerClick={false} size='tiny' centered={false}>
                <Modal.Header>Passwort zurücksetzen</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        {
                            <div>
                                Bitte geben Sie Ihre E-Mailadresse ein und klicken Sie anschließend auf Passwort zurücksetzen.
                                Sie erhalten anschließend eine E-Mail mit weiteren Informationen.

                                <Form onSubmit={login} style={{
                                    marginTop: '20px'
                                }}>
                                {
                                    (error)?
                                        <Message negative>{error.message}</Message>
                                    :null
                                }
                                    <Form.Field>
                                        <label>E-Mail</label>
                                        <Form.Input name='email' value={email} onChange={(e, {name, value}) => {
                                            setEmail(value)
                                        }} placeholder='Ihre E-Mailadresse' />
                                    </Form.Field>
                                </Form>
                            </div>
                        }
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button negative labelPosition='left' icon='remove' onClick={() => {
                        setError(null);
                        setShowReset(false);
                    }} content='Abbruch' />

                    <Button onClick={sendPasswordResetEmail}
                        positive
                        labelPosition='right'
                        icon='arrow right'
                        content='Passwort zurücksetzen'
                    />
                    </Modal.Actions>
            </Modal>  
        :
            <Modal open={true} closeOnDimmerClick={false} size='tiny' centered={false}>
                <Modal.Header>Anmelden</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        {
                            (loading)?
                                <div><Loader active inline='centered' /></div>
                            :
                                <div>
                                    <Form onSubmit={login}>
                                    {
                                        (error)?
                                            <Message negative>{error.message}</Message>
                                        :null
                                    }
                                        <Form.Field>
                                            <label>E-Mail</label>
                                            <Form.Input name='email' value={email} onChange={(e, {name, value}) => {
                                                setEmail(value)
                                            }} placeholder='Ihre E-Mailadresse' />
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Passwort</label>
                                            <Form.Input type="password" name='password' value={password} onChange={(e, {name, value}) => {
                                                setPassword(value)
                                            }} placeholder='Ihr Passwort' />
                                        </Form.Field>
                                    </Form>
                                </div>
                        }
                        
                        <div style={{
                            marginTop: '10px'
                        }}>
                            <a href="#" onClick={() => {
                                setError(null);
                                setShowReset(true);
                            }}>Passwort vergessen?</a>
                        </div>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={login}
                        positive
                        labelPosition='right'
                        icon='arrow right'
                        content='Anmelden'
                    />
                    </Modal.Actions>
            </Modal> 
    } 
    </div>
  )
}